import { defineComponent as _defineComponent } from 'vue'
import { PropType, ref, watch } from 'vue'

// PROPS

export default /*#__PURE__*/_defineComponent({
  __name: 'LfRadioGroupComponent',
  props: {
  options: {
    type: Array as PropType<any[]>,
    default: () => []
  },
  value: {
    type: [Number, String] as PropType<number | string>
  },
  itemKey: {
    type: String as PropType<string>,
    required: true
  },
  itemText: {
    type: String as PropType<string>,
    required: true
  }
},
  emits: ['update-value'],
  setup(__props, { emit }) {

const props = __props;



// DATA
const selectedValue = ref(props.value)

// WATCH
watch(
  () => props.value,
  (newValue) => {
    selectedValue.value = newValue
  }
)

// EVENTS


// METHODS
const handleRadioChange = () => {
  emit('update-value', selectedValue.value)
}

return { __sfc: true,props, selectedValue, emit, handleRadioChange }
}

})